import React, { useMemo } from "react";
import { get } from "lodash";
import { Paragraph, useColorTokens } from "@tvg/design-system";
import { exoticsBet, picksBet } from "@tvg/desktop-bet/src/utils/betUtils";
import { WagerResultsProps } from "./types";
// Utils
import { getSelectionsFromString } from "./utils";

import WagerResult from "./WagerResult";
import { Container, Header, List, ListItem } from "./styled-components";

const WagerResults = ({
  results,
  saddleType,
  raceNumber
}: WagerResultsProps) => {
  const colorTokens = useColorTokens();
  const payoffs = get(results, "payoffs", []);

  const renderWagerResults = useMemo(
    () =>
      payoffs &&
      payoffs
        .filter(
          (item) =>
            exoticsBet.includes(item.wagerType.code) ||
            picksBet.includes(item.wagerType.code)
        )
        .map((item, index) => {
          const isPick = picksBet.includes(item.wagerType.code);
          const isRefund =
            get(item, "selections[0].selection", "").toLowerCase() === "refund";
          const payout = get(item, "selections[0].payoutAmount", 0);
          const selection = get(item, "selections[0].selection", "");
          // remove double spaces from string ex: "3 OF  3 4-5-6"
          const singleSpacesSelection = selection.replace(/  +/g, " ");
          const pickStr = Object(singleSpacesSelection.match(/\d\sof\s\d/i))[0];
          const selections = isRefund
            ? []
            : getSelectionsFromString(selection, isPick, saddleType);

          return (
            <ListItem key={index.toString()}>
              <WagerResult
                selectionsDirection={isPick ? "col" : "row"}
                amount={item.wagerAmount}
                betName={item.wagerType.name}
                payout={payout}
                selections={selections}
                isRefund={isRefund}
                isPick={isPick}
                raceNumber={raceNumber}
                pickStr={pickStr}
              />
            </ListItem>
          );
        }),
    [payoffs]
  );

  return payoffs ? (
    <Container>
      <Header>
        <Paragraph
          mr="space-2"
          qaLabel="wager-title"
          color={colorTokens.content.default}
          fontFamily="medium"
        >
          Wager
        </Paragraph>
        <Paragraph
          ml="auto"
          qaLabel="payout-title"
          color={colorTokens.content.default}
          fontFamily="medium"
        >
          Payout
        </Paragraph>
      </Header>
      <List>{renderWagerResults}</List>
    </Container>
  ) : null;
};

export default WagerResults;
